// This is based on https://github.com/danielsneijers/react-flash-message.

import React, { useState } from "react";

import Snackbar from "@mui/material/Snackbar";

import SnackbarContent from "components/Snackbar/SnackbarContent.js";

import Check from "@mui/icons-material/Check";
import Warning from "@mui/icons-material/Warning";

export default function PageTopMessage(props) {
  const { isMessage, messageType, messageText } = props.messageState;
  const [open, setOpen] = useState(true);

  function handleClose(event, reason) {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  }

  if (!isMessage) {
    return null;
  }

  return (
    <Snackbar
      anchorOrigin={{
        vertical: "top",
        horizontal: "center",
      }}
      open={open}
      autoHideDuration={5000}
      onClose={handleClose}
    >
      {/* MUI v5 Snackbar transitions require a child that can hold a DOM ref */}
      <div>
        <SnackbarContent
          message={
            <span>
              <b style={{ textTransform: "uppercase" }}>{messageType}: </b>
              {messageText}
            </span>
          }
          color={messageType}
          icon={messageType === "warning" ? Warning : Check}
          close
        />
      </div>
    </Snackbar>
  );
}
